import { MELCO_HOOP_VERSION } from "../../../helper/hoopHelper";
import { SelectField } from "melco-shared-logic";

type HoopVersionSelectProps = {
    onChange?: (obj: any) => void;
    value?: string;
    // mode?: string;
}

export const HoopVersionSelect: React.FC<HoopVersionSelectProps> = ({ onChange, value }) => {

    let options = [];

    options = MELCO_HOOP_VERSION.split(",").map((v) => {
        return {
            label: v,
            value: v
        }
    })
    return <>
        <SelectField
            name="version"
            allowClear
            options={options}
            style={{ width: "100%", minWidth: "150px" }}
            // mode={mode == "multiple" ? "multiple" : undefined}
            value={"5"}
        //onChange={onChange}

        />
    </>
}